<template>
  <div class="about-us section-container">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="section-container-spacer text-center">
            <h1 class="h2">04 : 关于我们</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- pc端样式 -->
    <template v-if="!isMobile">
      <div class="pc-mode banner-bottom">
        <div class="container timeline-box">
          <div class="banner-bottom-left">
            <div class="base-year year2018">
              <h3>2018</h3>
              <p>12月 waf-china--赛事中国赛区官方网站 && 小程序
                <span>10月 餐悟--微信公众号平台</span>
                <span>8月 OnCycle健身房--微信小程序健身房预约系统</span>
                <span>6月 淄博危化--政府危险化学品运输监管平台</span>
                <span>5月 领军唐山人脸识别项目--校园门禁监管系统</span>
                <span>3月 甘肃铁塔项目--国家甘肃铁塔系统</span>
              </p>
            </div>
            <div class="year-pos">
              <img src="../assets/images/aboutUs/circle-1.png" alt=""></img>
            </div>
            <div class="base-year year2016">
              <h3>2016</h3>
              <p>11月 智选派-餐饮服务行业的『滴滴』平台，餐厅发单、智能派给注册的服务员，按次结算费用
                <span>10月 通过《国家高新技术企业》认定</span>
                <span>4月 卜丁坊-互联网家纺品牌，打造C端家纺消费生态圈</span>
                <span>5月 获得11项软件著作专利权</span>
              </p>
            </div>
            <div class="year-pos1">
              <img src="../assets/images/aboutUs/circle-3.png" alt=""></img>
            </div>
            <div class="base-year year2014">
              <h3>2014</h3>
              <p>10月 合禾在线教育-在线教育平台：包含付费视频、在线课堂、学员社区等子系统
                <span>8月 农场来了-生鲜农产品交易电商系统（B2B2C系统），包含前台交易、农场商家入驻、平台进销存、物流仓储移动POS管理等子系统</span>
                <span>6月 高校设备管理平台-西南交通大学实验室设备管理和计费系统</span>
                <span>5月 激战足球-足球类O2O：集在线订场、赛事组织和球友约球的综合性平台</span>
                <span>2月 澳澳网红酒电商-澳洲顶级进口红酒电商平台</span>
              </p>
            </div>
            <div class="year-pos2">
              <img src="../assets/images/aboutUs/circle-2.png" alt=""></img>
            </div>
          </div>
          <div class="banner-bottom-right">
            <div class="base-year year2017">
              <h3>2017</h3>
              <p>11月 高等院校竞赛系统-全国大学生专业竞赛系统，支持多校报名、题库管理、实时出分排名
                <span>8月 卜丁布草-民宿家纺一站式服务平台、包含布草下单租赁、清洗配送等</span>
                <span>7月 留学中介企业办公OA系统-客户咨询、签约、留学服务全流程OA平台</span>
                <span>6月 餐饮SaaS系统-包含前台收银端、点菜宝、门店管理、报表、排队、老版客户端等完整的餐饮管理系统</span>
                <span>5月 丝绸之路英文大赛-英语知识和朗读大赛，全程云端智能比对系统</span>
                <span>4月 展会票务系统-包含前期宣传、在线销售和现场核销等子系统</span>
                <span>3月 工程进度管理系统-为四川水利设计院定制开发系统，包含任务分配、进度监控、在线审核等子系统</span>
              </p>
            </div>
            <div class="year-pos3">
              <img src="../assets/images/aboutUs/circle-3.png" alt=""></img>
            </div>
            <div class="base-year year2015">
              <h3>2015</h3>
              <p>11月 视频大数据分析平台-与哈尔滨工业大学研发合作，为中视广联集团开发对全国电视、电台媒体的音视频频大数据进行智能分析和人工标注的系统
                <span>7月 广告交易网-在线广告交易平台，包含报纸、电台和电视台媒体资源</span>
                <span>6月 公司全资购买办公室，入驻成都高新区核心CBD</span>
                <span>4月 违法广告公示平台-国家工商总局广告监督管理司内部使用</span>
              </p>
            </div>
            <div class="year-pos4">
              <img src="../assets/images/aboutUs/circle-4.png" alt=""></img>
            </div>
            <div class="base-year year2013">
              <h3>2013</h3>
              <p>11月 一庐艺术-与成都蓝顶艺术中心合作，开发在线艺术品展厅和艺术类书籍v电商平台
                <span>9月 美食厨房APP-为美的集团小家电事业部定制开发，配合其新品微波炉套件宣传</span>
                <span>5月 公司成立，三位创始人均毕业于西安交通大学</span>
              </p>
            </div>
            <div class="year-pos5">
              <img src="../assets/images/aboutUs/circle-3.png" alt=""></img>
            </div>
          </div>
        </div>
        <div class="clearfix"> </div>
      </div>
    </template>
    <!-- pc端样式 -->
    <!-- 手机端端样式 -->
    <template v-else>
      <div class="mobile-mode container">
        <div class="year-item">
          <h3>2018</h3>
          <p>12月 waf-china--赛事中国赛区官方网站 && 小程序
            <span>10月 餐悟--微信公众号平台</span>
            <span>8月 OnCycle健身房--微信小程序健身房预约系统</span>
            <span>6月 淄博危化--政府危险化学品运输监管平台</span>
            <span>5月 领军唐山人脸识别项目--校园门禁监管系统</span>
            <span>3月 甘肃铁塔项目--国家甘肃铁塔系统</span>
          </p>
        </div>
        <div class="year-item">
          <h3>2017</h3>
          <p>11月 高等院校竞赛系统-全国大学生专业竞赛系统，支持多校报名、题库管理、实时出分排名
            <span>8月 卜丁布草-民宿家纺一站式服务平台、包含布草下单租赁、清洗配送等</span>
            <span>7月 留学中介企业办公OA系统-客户咨询、签约、留学服务全流程OA平台</span>
            <span>6月 餐饮SaaS系统-包含前台收银端、点菜宝、门店管理、报表、排队、老版客户端等完整的餐饮管理系统</span>
            <span>5月 丝绸之路英文大赛-英语知识和朗读大赛，全程云端智能比对系统</span>
            <span>4月 展会票务系统-包含前期宣传、在线销售和现场核销等子系统</span>
            <span>3月 工程进度管理系统-为四川水利设计院定制开发系统，包含任务分配、进度监控、在线审核等子系统</span>
          </p>
        </div>
        <div class="year-item">
          <h3>2016</h3>
          <p>11月 智选派-餐饮服务行业的『滴滴』平台，餐厅发单、智能派给注册的服务员，按次结算费用
            <span>10月 通过《国家高新技术企业》认定</span>
            <span>4月 卜丁坊-互联网家纺品牌，打造C端家纺消费生态圈</span>
            <span>5月 获得11项软件著作专利权</span>
          </p>
        </div>
        <div class="year-item">
          <h3>2015</h3>
          <p>11月 视频大数据分析平台-与哈尔滨工业大学研发合作，为中视广联集团开发对全国电视、电台媒体的音视频频大数据进行智能分析和人工标注的系统
            <span>7月 广告交易网-在线广告交易平台，包含报纸、电台和电视台媒体资源</span>
            <span>6月 公司全资购买办公室，入驻成都高新区核心CBD</span>
            <span>4月 违法广告公示平台-国家工商总局广告监督管理司内部使用</span>
          </p>
        </div>
        <div class="year-item">
          <h3>2014</h3>
          <p>10月 合禾在线教育-在线教育平台：包含付费视频、在线课堂、学员社区等子系统
            <span>8月 农场来了-生鲜农产品交易电商系统（B2B2C系统），包含前台交易、农场商家入驻、平台进销存、物流仓储移动POS管理等子系统</span>
            <span>6月 高校设备管理平台-西南交通大学实验室设备管理和计费系统</span>
            <span>5月 激战足球-足球类O2O：集在线订场、赛事组织和球友约球的综合性平台</span>
            <span>2月 澳澳网红酒电商-澳洲顶级进口红酒电商平台</span>
          </p>
        </div>
        <div class="year-item">
          <h3>2013</h3>
          <p>11月 一庐艺术-与成都蓝顶艺术中心合作，开发在线艺术品展厅和艺术类书籍v电商平台
            <span>9月 美食厨房APP-为美的集团小家电事业部定制开发，配合其新品微波炉套件宣传</span>
            <span>5月 公司成立，三位创始人均毕业于西安交通大学</span>
          </p>
        </div>
      </div>
    </template>
    <!-- 手机端端样式 -->
    <!-- 企业资质证书 -->
    <section class="company-certificate container">
      <div class="col-sm-8 col-sm-offset-2 section-container-spacer">
        <div class="text-center">
          <h3>软件著作</h3>
        </div>
      </div>
      <div class="col-md-12">
        <div id="certificate" class="carousel slide projects-carousel">
          <!-- Carousel items -->
          <div class="carousel-inner">
            <div class="item active">
              <div class="row">
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/1.jpg" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/2.jpg" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/3.jpg" alt="" class="img-responsive">
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row">
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/4.jpg" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/5.jpg" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/6.jpg" alt="" class="img-responsive">
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row">
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/7.jpg" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/8.jpg" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-4">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/9.jpg" alt="" class="img-responsive">
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="col-sm-4">
                <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/10.jpg" alt="" class="img-responsive">
                  </a>
              </div>
              <div class="col-sm-4">
                <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/certificate/11.jpg" alt="" class="img-responsive">
                  </a>
              </div>
            </div>
          </div>
          <template>
            <a class="left carousel-control" href="#certificate" data-slide="prev">‹</a>
            <a class="right carousel-control" href="#certificate" data-slide="next">›</a>
          </template>
        </div>
      </div>
    </section>
    <!-- 企业资质证书 -->
    <!-- 合作伙伴 -->
    <section class="company-partner container" :class="{ 'mobile-partner': isMobile }">
      <div class="col-sm-8 col-sm-offset-2 section-container-spacer">
        <div class="text-center">
          <h3>合作伙伴</h3>
        </div>
      </div>
      <div class="col-md-12">
        <div id="partner" class="carousel slide projects-carousel">
          <!-- Carousel items -->
          <div class="carousel-inner">
            <div class="item active">
              <div class="row">
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/1.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/2.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/3.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/4.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/5.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/6.png" alt="" class="img-responsive">
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row">
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/7.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/8.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/9.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/10.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/11.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/12.png" alt="" class="img-responsive">
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row">
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/13.png" alt="" class="img-responsive">
                  </a>
                </div>
                <div class="col-sm-2">
                  <a  title="" class="black-image-project-hover">
                    <img src="../assets/images/partner/14.png" alt="" class="img-responsive">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <template>
            <a class="left carousel-control" href="#partner" data-slide="prev">‹</a>
            <a class="right carousel-control" href="#partner" data-slide="next">›</a>
          </template>
        </div>
      </div>
    </section>
    <!-- 合作伙伴 -->
  </div>
</template>
<script>
import { isMobile } from '@/utils/index.js'

export default {
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      isMobile,
    }
  },
  watch: {},
  methods: {},
  mounted() {},
}
</script>
<style lang="scss">
.about-us {
  background: #fff;

  /* pc的版式 */
  .pc-mode {
    &.banner-bottom {
      background: #fff;
      position: relative;
    }

    .banner-bottom-left {
      float: left;
      width: 45%;
      text-align: right;
    }

    .base-year h3 {
      color: #000;
      font-size: 35px;
      margin: 0;
      font-style: normal;
    }

    .base-year p {
      color: #000;
      font-size: 13px;
      margin: 1em 0 0;
      font-style: normal;
    }

    .base-year p span {
      display: block;
    }

    .banner-bottom-right {
      float: right;
      width: 50%;
      border-left: 5px solid #000;
      text-align: left;
      padding-left: 5%;
    }

    .year2018 {
      margin-top: 4em;
    }

    .year2017 {
      margin-top: 22em;
    }

    .year2016 {
      margin-top: 27em;
    }

    .year2015 {
      margin-top: 17em;
    }

    .year2014 {
      margin-top: 17em;
    }

    .year2013 {
      margin-top: 19em;
    }

    .year-pos {
      position: absolute;
      top: 4.5%;
      left: 50%;
      margin-left: -8.5px;
    }

    .year-pos1 {
      position: absolute;
      top: 19.5%;
      left: 50%;
      margin-left: -20.5px;
    }

    .year-pos2 {
      position: absolute;
      top: 44%;
      left: 50%;
      margin-left: -8.5px;
    }

    .year-pos3 {
      position: absolute;
      top: 57.5%;
      left: 50%;
      margin-left: -20.5px;
    }

    .year-pos4 {
      position: absolute;
      top: 73%;
      left: 50%;
      margin-left: -8.5px;
    }

    .year-pos5 {
      position: absolute;
      top: 88%;
      left: 50%;
      margin-left: -20.5px;
    }
  }

  /* mobile */
  .mobile-mode {
    .year-item {
      margin-bottom: 30px;

      h3 {
        margin-bottom: 20px;
      }

      span {
        display: block;
        margin-bottom: 10px;
      }
    }
  }

  .company-certificate {
    margin-top: 40px;
  }

  .company-partner {
    margin-top: 40px;

    &.mobile-partner {
      .img-responsive {
        width: 100%;
      }
    }
  }

}
</style>